import React from 'react'
import PropTypes from 'prop-types'

import cn from 'classnames'
import { isUndefined } from 'lodash'

import HighSchoolOverview from './HighSchoolOverview'
import EmptyRail from './EmptyRail'

import './index.scss'

class HighSchoolMapRail extends React.Component {
  render() {
    return (
      <div className={cn({ open: !isUndefined(this.props.selectedHighSchoolId) }, 'high-school-map-rail')}>
        <div className="animated-wrapper">
          <div className="panel-1">{this.props.defaultView}</div>
          <div className="panel-2">
            <HighSchoolOverview
              onOverviewClose={this.props.onOverviewClose}
              detailSchoolId={this.props.selectedHighSchoolId}
            />
          </div>
        </div>
      </div>
    )
  }
}

HighSchoolMapRail.propTypes = {
  defaultView: PropTypes.element.isRequired,
  selectedHighSchoolId: PropTypes.string,
  onOverviewClose: PropTypes.func,
}

HighSchoolMapRail.Empty = EmptyRail

export default HighSchoolMapRail
